import { Theme } from "@mui/material";
import { SxProps, SystemStyleObject } from "@mui/system";
import { lighten } from "@mui/material/styles";
import { COLORS } from "../../../../constants";
import { SizeData } from "./constants";

interface Props {
  sizeData: SizeData;
}

/**
 * label styles
 */
export const inputLabelSxPropsFn = ({
  sizeData,
}: Props): SystemStyleObject => ({
  fontSize: sizeData.fontSize,
  transform: `translate(14px, ${sizeData.label}) scale(1)`,
  "&.MuiInputLabel-shrink": {
    transform: "translate(14px, -9px) scale(0.75)",
  },
});

/**
 * hide input so chip can be used
 */
export const formControlAsChipSxProps = {
  display: "none",
  background: "#ff00",
};

/**
 * Popover menu styles
 */
export const menuSxProps = {
  ".MuiList-root": {
    paddingTop: 0,
  },
  ".MuiPaper-root": (theme: Theme): SxProps<Theme> => ({
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  }),
} as SystemStyleObject;

/**
 * select styles
 */
export const selectSxProps = ({ sizeData }: Props): SxProps<Theme> => ({
  ".MuiOutlinedInput-notchedOutline": {
    legend: {
      fontSize: sizeData.legend,
    },
  },
  ".MuiSelect-outlined": {
    color: COLORS.P_MED_HIGH_EMPHASIS,
    "&.MuiSelect-select": {
      textAlign: "left",
      textAlignLast: "left",
      minHeight: "0",
      height: "auto",
      pr: 7,
      pl: 3,
      lineHeight: "20px",
      pt: sizeData.padding,
      pb: sizeData.padding,
      display: "flex",
      alignItems: "center",
    },
  },
  ".MuiSelect-icon": {
    width: "19px",
  },
});

/**
 * Popover menu Item styles
 */
export const menuItemSxProps = {
  minWidth: "110px",
  "&.Mui-selected": {
    background: (theme: Theme): string =>
      lighten(theme.palette.primary.main, 0.88),
  },
  "&.Mui-focused": {
    background: (theme: Theme): string =>
      lighten(theme.palette.primary.main, 0.88),
  },
  "&:hover": {
    background: (theme: Theme): string =>
      lighten(theme.palette.primary.main, 0.88),
  },
  minHeight: [32, null],
};
